const two = (n) => String(n).padStart(2, "0");

// Дата для поля <input type="date"> («2026-12-05»): день из переданного значения (дата
// напоминания из базы). Сегодняшний день подставляется только если значения нет или оно не
// читается, а не вместо сохранённой даты.
export const dateInputValue = (value, now = new Date()) => {
  const parsed = value ? new Date(value) : null;
  const date = parsed && !Number.isNaN(parsed.getTime()) ? parsed : now;
  return `${date.getFullYear()}-${two(date.getMonth() + 1)}-${two(date.getDate())}`;
};
